module.exports = (__webpack_require__(0))(107);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/MetadataWidget.js from dll-reference girder_lib
// module id = 226
// module chunks = 0